import { render } from "./ItemList.vue?vue&type=template&id=42417d70"
const script = {}
script.render = render

export default script